import Alert from 'common/components/alert/Alert';
import CustomTooltip from 'common/components/custom-tooltip/CustomTooltip';
import FinalFormField from 'common/components/final-form/FinalFormField';
import AlertType from 'common/types/AlertType';
import { ValidationObj } from 'common/types/ValidationObj';
import DraftApplication from 'domain/types/DraftApplication';
import { Col, FormCheck, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { useForm } from 'react-final-form';

interface IContact {
  profileEmail: string;
  data: DraftApplication;
  errors: ValidationObj;
}

const Contact = (props: IContact) => {
  const isProfileEmail = props.data.email === props.profileEmail;
  const isOther = !isProfileEmail && props.data.email !== null;
  const form = useForm<DraftApplication>();
  const errors = Object.values(props.errors).filter((v) => Boolean(v));

  return (
    <>
      {errors.length > 0 && (
        <Alert type={AlertType.danger}>
          {
            <ul>
              {errors.map((e, index) => (
                <li key={index}>{e as string}</li>
              ))}
            </ul>
          }
        </Alert>
      )}
      <p>
        Please choose what email you would like linked to this application.
        <CustomTooltip name='please-choose' className='ml-3'>
          All status updates for this application will be sent to this email.
        </CustomTooltip>
      </p>
      <FormGroup as={Row} className='flex-nowrap'>
        <Col
          sm={{ span: 1, offset: 1 }}
          className='align-self-center auto-width'
        >
          <FormCheck
            type='radio'
            id='profile-email'
            checked={isProfileEmail}
            onChange={() => form.change('email', props.profileEmail)}
          />
        </Col>
        <FormLabel column sm='10' htmlFor='profile-email'>
          {props.profileEmail}
        </FormLabel>
      </FormGroup>
      <FormGroup as={Row} className='flex-nowrap'>
        <Col
          sm={{ span: 1, offset: 1 }}
          className='align-self-center auto-width'
        >
          <FormCheck
            type='radio'
            id='other-email'
            checked={isOther}
            onChange={() => form.change('email', '')}
          />
        </Col>
        <FormLabel column sm='10' htmlFor='other-email'>
          Other
        </FormLabel>
      </FormGroup>
      {isOther && props.data.email !== null && (
        <FormGroup as={Row}>
          <Col sm={{ span: 1, offset: 1 }} />
          <Col sm='6'>
            <FinalFormField
              name='email'
              placeholder='i.e., email@email.com'
              type='text'
              label=''
            />
          </Col>
        </FormGroup>
      )}
    </>
  );
};

export default Contact;
